import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table } from 'semantic-ui-react';

import RowActionMenu from './RowActionMenu';
import { QUEUE_COLUMN, VALUE_PLACEHOLDER } from '../../constants/onboardingQueue';
import {
  attemptCount,
  contactInfo,
  daysAgoLabel,
  hasAgreedPrice,
  operatorLabel,
  priceProps,
  statusLabel,
  wallClockDate,
} from '../../utilities/onboardingQueue';

const contactCell = record => {
  const { email, phone } = contactInfo(record.dealerEmail, record.dealerPhone);
  return (
    <div>
      <div data-testid='queue-contact-email'>{email}</div>
      <div data-testid='queue-contact-phone'>{phone}</div>
    </div>
  );
};

const priceCell = record => (
  hasAgreedPrice(record.subscriptionPrice)
    ? React.createElement(FormattedNumber, priceProps(record.subscriptionPrice))
    : VALUE_PLACEHOLDER
);

const CELL_RENDERERS = {
  [QUEUE_COLUMN.CUSTOMER]: record => record.dealerName || VALUE_PLACEHOLDER,
  [QUEUE_COLUMN.CUSTOMER_ID]: record => (
    record.customerId == null || record.customerId === ''
      ? VALUE_PLACEHOLDER
      : record.customerId
  ),
  [QUEUE_COLUMN.OFFER_ACCEPTED]: record => wallClockDate(record.offerAcceptedDate),
  [QUEUE_COLUMN.AGE]: record => daysAgoLabel(record.createdAt),
  [QUEUE_COLUMN.CONTACT_INFO]: contactCell,
  [QUEUE_COLUMN.COMPLETED_AT]: record => wallClockDate(record.completedAt),
  [QUEUE_COLUMN.OPERATOR]: record => operatorLabel(record.updatedBy),
  [QUEUE_COLUMN.PRICE]: priceCell,
  [QUEUE_COLUMN.STATUS]: record => statusLabel(record.status),
  [QUEUE_COLUMN.ATTEMPTS]: record => attemptCount(record),
  [QUEUE_COLUMN.ACTIONS]: (record, { view, onAction }) => (
    <RowActionMenu view={view} record={record} onAction={onAction} />
  ),
};

const OnboardingQueueListRow = (columns, handlers) => record => {
  const { flatRateOfferId } = record;

  return (
    <Table.Row key={flatRateOfferId} data-testid='queue-row'>
      {columns.map(column => (
        <Table.Cell
          key={column.key}
          data-testid={`queue-cell-${column.key}`}
        >
          {CELL_RENDERERS[column.key]
            ? CELL_RENDERERS[column.key](record, handlers)
            : VALUE_PLACEHOLDER}
        </Table.Cell>
      ))}
    </Table.Row>
  );
};

export default OnboardingQueueListRow;
